import { useMutation } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

const UPDATE_JOB = gql`
  mutation UpdateJob($input: JobUpdateInput!) {
    updateJob(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/UpdateJob').type;
export type UpdateJobVariables = OperationVariables<typeof UPDATE_JOB>;
export type UpdateJobResult = OperationData<typeof UPDATE_JOB>;
export type UpdateJobInput = UpdateJobVariables['input'];

export const useUpdateJob = () => {
  const tuple = useMutation(UPDATE_JOB);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        refetchQueries: ['GetJob'],
        // refetchQueries: [
        //   {
        //     query: getJobQuery,
        //     variables: { cloudId: options.variables.cloudId },
        //   },
        // ],
        // update(cache) {
        // cache.evict({ fieldName: 'jobGetRecurrences' });
        // cache.evict({ fieldName: 'searchTasks' });
        // I think it was deliberate that we are not evicting searchJobs here?
        // so that if the user is working through a list of jobs, editing them, the search doesn't keep changing on them?
        // that's it, that's all I have. Feels more like a bug to me
        // },
        awaitRefetchQueries: true,
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
